import React from "react";
import AnchorButton from "../../components/AnchorButton";
import Headline from "../../components/Headline";
import { MainLayout } from "../../components/Layout";
import LinkButton from "../../components/LinkButton";
import SmartButton from "../../components/SmartButton";
import { useEmailUnsubscribePage } from "../../page-hooks/email-unsubscribe";
import { URL_PATHS } from "../../routes";
import { oneLink } from "../../shared/oneLink";
import "./styles.scss";

const EmailUnsubscribe = () => {
    const { usecase, query } = useEmailUnsubscribePage();
    if (query.unsubscribeFinish) {
        return (
            <MainLayout isBurgerHidden={true}>
                <Headline>
                    パートナーエージェントAppからメール配信を停止
                </Headline>
                <div className="title">メール配信の停止が完了しました。 </div>

                <div className="user-action">
                    <AnchorButton href={oneLink()}>アプリを開く</AnchorButton>
                    <LinkButton color="secondary" to={URL_PATHS.myPage()}>
                        マイページへ
                    </LinkButton>
                </div>
            </MainLayout>
        );
    }
    return (
        <MainLayout isBurgerHidden={true}>
            <Headline>パートナーエージェントAppからメール配信を停止</Headline>
            <div className="title">
                パートナーエージェントAppからのメール配信を停止してもよろしいですか？規約変更等の重要なメールは停止されません。
            </div>

            <SmartButton
                type="button"
                mode="secondary"
                onClick={usecase.onRequestEmailUnsubscribe}
                disabled={query.loading}
                isLoading={query.loading}
            >
                停止する
            </SmartButton>
        </MainLayout>
    );
};

export default EmailUnsubscribe;
